import { OpenInNew } from '@mui/icons-material';
import {
  Box,
  Divider,
  Grid,
  Typography,
  Paper,
  Skeleton,
  SxProps,
  Theme,
} from '@mui/material';

import { LinkButton } from 'components';
import { colors } from 'config/theme';
export const BarometerCard = (props: {
  barometer: number | undefined;
  directTo?: string;
  indicator?: { label: string; value: string };
  sx?: SxProps<Theme> | undefined;
  arialabel?: string;
}) => {
  const { barometer, indicator, directTo, sx, arialabel } = props;
  return (
    <Box sx={sx}>
      {typeof barometer === 'number' ? (
        <Paper
          sx={{
            padding: 2,
            height: 250,
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          {directTo && (
            <LinkButton
              sx={{
                alignSelf: 'end',
              }}
              to={directTo}
              aria-label={arialabel}
            >
              <OpenInNew fontSize='small' sx={{ color: 'black' }} />
            </LinkButton>
          )}
          <Typography
            sx={{
              color: colors.uswds.primary.vivid,
              margin: 'auto',
              verticalAlign: 'middle',
            }}
            variant='h1'
          >
            {barometer.toLocaleString('en-US')}
          </Typography>

          {indicator && (
            <Box sx={{ marginTop: 'auto' }}>
              <Divider sx={{ mb: 2 }} />
              <Grid container>
                <Grid
                  item
                  xs={10}
                  style={{ display: 'flex', justifyContent: 'flex-start' }}
                >
                  <Typography noWrap display='inline' variant='body1'>
                    {indicator.label}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={2}
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                >
                  <Typography
                    align='right'
                    display='inline'
                    color={colors.uswds.primary.vivid}
                  >
                    {indicator.value}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          )}
        </Paper>
      ) : (
        <Box sx={{ pt: 0.5 }}>
          <Skeleton variant='rectangular' width='100%' height={220} />
          <Skeleton variant='rectangular' width='100%' />
        </Box>
      )}
    </Box>
  );
};
